import React from "react";
import { Box, Grid, Card, Typography, Button, Dialog,DialogContent,IconButton
 } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PlansImg from "../assets/plan_details_pamplet.jpg";
import { jsPDF } from "jspdf";

export default function PremiumPlans() {

const [open, setOpen] = React.useState(false);

  const plans = [
    {
      name: "Entry Plan",
      badgeColor: "#FF6F00",
      validity: "Valid for 10 Days",
      points: [
        "Entry For Suyamvaram and Events",
        "10 Matching Profiles will be given",
        "Added to WhatsApp Group with daily updated profiles",
      ],
    },
    {
      name: "Silver Plan",
      badgeColor: "#9C27B0",
      validity: "Valid for 100 Days",
      points: [
        "30 Contacts Will be Provided",
        "25+ Matching Profiles Provided",
        "Added to WhatsApp Updated Profiles Group",
        "Office Visit Monthly Once",
        "Profile Files + CRM Allocated",
      ],
    },
    {
      name: "Gold Plan",
      badgeColor: "#CFA401",
      validity: "Valid for 180 Days",
      points: [
        "60 Contacts will be Provided",
        "Personal CRM (End-to-End Service)",
        "Assisted VIP Services",
        "Bride/Groom Group List",
        "Office Visit Monthly Twice",
        "Free Astrologer Advice",
        "CRM Joins During Bride/Groom Meet & Arrangements",
      ],
    },
    {
      name: "Platinum Plan",
      badgeColor: "#00897B",
      validity: "Valid for 365 Days",
      points: [
        "100 Contacts Will be Provided",
        "Office Visit Monthly Thrice",
        "All Gold Plan Benefits",
        "First-Level Matchmaking",
        "Service Continues Until Marriage Completion",
      ],
    },
  ];

  const handleDownloadPDF = () => {
    const pdf = new jsPDF("p", "mm", "a4");

    const img = new Image();
    img.src = PlansImg;
    img.onload = function () {
      const imgWidth = 190; 
      const imgHeight = (img.height * imgWidth) / img.width;

      pdf.addImage(img, "JPEG", 10, 10, imgWidth, imgHeight);
      pdf.save("vivahasangamam_plandetails.pdf");
    };
  };

  return (
    <Box
      sx={{
        py: 6,
        px: { xs: 2, md: 6 },
        background: "#faf6f2",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          maxWidth: "1250px",
          width: "100%",
          background: "#f4fff8",
          p: { xs: 3, md: 5 },
          borderRadius: "18px",
          boxShadow: "0 6px 22px rgba(0,0,0,0.12)",
        }}
      >
        {/* Section Title */}
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: 700,
            color: "#BF0603",
            fontFamily: "Quicksand",
            mb: 4,
            fontSize: { xs: "24px", md: "28px" },
          }}
        >
          Our Premium Matchmaking Plans
        </Typography>

        {/* Plans Grid */}
        <Grid
          container
          spacing={3}
          justifyContent="center"
          alignItems="stretch"
          sx={{ mt: 2 }}
        >
          {plans.map((plan, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={3}
              key={index}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Card
                sx={{
                  width: "100%",
                  height: "100%",
                  p: 3,
                  borderRadius: "14px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                  transition: "0.3s",
                  "&:hover": {
                    transform: "translateY(-5px)",
                    boxShadow: "0 8px 25px rgba(0,0,0,0.2)",
                  },
                  backgroundColor: "#fff",
                }}
              >
                {/* Plan Badge */}
                <Box
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    background: plan.badgeColor,
                    color: "#fff",
                    px: 1.6,
                    py: 0.5,
                    borderRadius: "6px",
                    fontSize: "12px",
                    fontWeight: 600,
                    textTransform: "uppercase",
                    fontFamily : 'Quicksand'
                  }}
                >
                  {plan.name}
                </Box>

                {/* Plan Header */}
                <Typography
                  sx={{
                    fontSize: "19px",
                    fontWeight: 700,
                    mb: 1,
                    fontFamily: "Quicksand",
                  }}
                >
                  {plan.name}
                </Typography>

                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 600,
                    color: "#D43725",
                    mb: 1.5,
                    fontFamily: "Varela Round",
                  }}
                >
                  {plan.validity}
                </Typography>

                {/* Scrollable Bullet List */}
                <Box
                  component="ul"
                  sx={{
                    listStyleType: "disc",
                    pl: 3,
                    pr: 1,
                    m: 0,
                    flexGrow: 1,
                    overflowY: "auto",
                    fontFamily: "Varela Round",
                    color: "#000",
                  }}
                >
                  {plan.points.map((point, i) => (
                    <li
                      key={i}
                      style={{
                        marginBottom: "6px",
                        fontSize: "13.5px",
                        lineHeight: 1.5,
                      }}
                    >
                      {point}
                    </li>
                  ))}
                </Box>
              </Card>
            </Grid>
          ))}
        </Grid>
        <Box sx={{ textAlign: "center", mt: 4 }}>
  <Button
    variant="contained"
    onClick={() => setOpen(true)}
    sx={{
      backgroundColor: "#BF0603",
      color: "#fff",
      px: 3,
      py: 1.2,
      fontSize: "16px",
      fontFamily: "Quicksand",
      borderRadius: "10px",
      "&:hover": { backgroundColor: "#a90402" }
    }}
  >
    View Details
  </Button>
</Box>
<Dialog
  open={open}
  onClose={() => setOpen(false)}
  maxWidth="md"
  fullWidth
  fullScreen={{ xs: true, sm: true }} // mobile full screen
  PaperProps={{
    sx: {
      borderRadius: { xs: 0, sm: "12px" },
      maxHeight: "90vh",
      background: "rgba(255, 255, 255, 0.15)",
      backdropFilter: "blur(12px)",
      WebkitBackdropFilter: "blur(12px)",

      boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
    },
  }}
>
  <DialogContent sx={{ p: 0, position: "relative" }}>
    {/* Close Button */}
    <IconButton
      onClick={() => setOpen(false)}
      sx={{
        position: "absolute",
        top: 10,
        right: 10,
        zIndex: 2,
        background: "#fff",
        "&:hover": { background: "#f0f0f0" }
      }}
    >
      <CloseIcon />
    </IconButton>
<Button
          variant="contained"
          color="primary"
          sx={{ mt: 2,ml: 3, backgroundColor: '#BF0603'}}
          onClick={handleDownloadPDF}
        >
          Download Plan Details
        </Button>
    {/* Responsive Image */}
    <img
      src={PlansImg}
      alt="Plan Details"
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
      }}
    />
  </DialogContent>
</Dialog>

      </Box>
    </Box>
  );
}
